import { render, staticRenderFns } from "./EwssAnakScoringMatrix.vue?vue&type=template&id=6049cc9b&scoped=true&"
import script from "./EwssAnakScoringMatrix.vue?vue&type=script&lang=ts&"
export * from "./EwssAnakScoringMatrix.vue?vue&type=script&lang=ts&"
import style0 from "./EwssAnakScoringMatrix.vue?vue&type=style&index=0&id=6049cc9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6049cc9b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCard,VCardText,VCardTitle,VChip,VSimpleTable,VSpacer})
